/* Farmacias LF · Home (sistema Cápsula)
   1. «Buscar mi medicamento» ([data-lf-focus-search]): enfoca el buscador visible del encabezado.
      Si no hay buscador visible, el enlace sigue a la página de búsqueda (comportamiento normal).
   2. Carrusel de productos ([data-lf-carr]): flechas anterior/siguiente en computador.
      Las flechas solo aparecen cuando hay más productos de los que caben.
   3. Bloque de bioequivalentes ([data-lf-be-box]): si se llega con su ancla (p. ej. /#bioequivalentes,
      enlace del mega menú), abre la explicación «¿Qué es un bioequivalente?».
*/
(() => {
  if (window.LFHome) return;

  /* ---------- 1. Enfocar el buscador del encabezado ---------- */
  const SEARCH_INPUT = 'input[type="search"], input[name="q"]';
  const HEADER_SCOPES = ['.shopify-section-group-header-group', '.lf-header', '.lf-mheader', 'header'];

  const isVisible = (el) => {
    if (!el || el.disabled || el.type === 'hidden') return false;
    if (!el.getClientRects().length) return false;
    const style = window.getComputedStyle(el);
    return style.visibility !== 'hidden' && style.display !== 'none';
  };

  const findHeaderSearch = () => {
    for (const scope of HEADER_SCOPES) {
      const inputs = document.querySelectorAll(`${scope} ${SEARCH_INPUT}`);
      for (const input of inputs) {
        if (isVisible(input)) return input;
      }
    }
    return null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lf-focus-search]');
    if (!trigger) return;
    const input = findHeaderSearch();
    if (!input) return;
    event.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    input.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    input.focus({ preventScroll: true });
    if (typeof input.select === 'function' && input.value) input.select();
  });

  /* ---------- 2. Carrusel de productos ---------- */
  const initCarr = (root = document) => {
    const carousels = root.matches && root.matches('[data-lf-carr]') ? [root] : root.querySelectorAll('[data-lf-carr]');
    carousels.forEach((carr) => {
      if (carr.dataset.lfCarrReady) return;
      const track = carr.querySelector('[data-lf-carr-track]');
      const prev = carr.querySelector('[data-lf-carr-prev]');
      const next = carr.querySelector('[data-lf-carr-next]');
      if (!track || !prev || !next) return;
      carr.dataset.lfCarrReady = '1';

      let frame = 0;
      const update = () => {
        frame = 0;
        const max = track.scrollWidth - track.clientWidth;
        const scrollable = max > 4 && window.getComputedStyle(track).overflowX !== 'visible';
        prev.hidden = !scrollable;
        next.hidden = !scrollable;
        if (!scrollable) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max - 4;
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };
      const step = (dir) => {
        const item = track.querySelector('.lf-carr__item');
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const itemWidth = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
        const perPage = Math.max(1, Math.floor((track.clientWidth + gap) / itemWidth));
        track.scrollBy({ left: dir * perPage * itemWidth });
      };

      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', schedule, { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(schedule).observe(track);
      } else {
        window.addEventListener('resize', schedule);
      }
      update();
    });
  };

  /* ---------- 3. Abrir la explicación de bioequivalentes al llegar por su ancla ---------- */
  const openBeFromHash = () => {
    const id = decodeURIComponent((window.location.hash || '').slice(1));
    if (!id) return;
    const box = document.getElementById(id);
    if (!box || !box.matches('[data-lf-be-box]')) return;
    const more = box.querySelector('[data-lf-be-more]');
    if (more && !more.open) more.open = true;
  };

  const init = () => {
    initCarr();
    openBeFromHash();
  };

  window.LFHome = { initCarr, findHeaderSearch, openBeFromHash };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('hashchange', openBeFromHash);
  document.addEventListener('shopify:section:load', (event) => initCarr(event.target));
})();
